import { Avatar, Box, Typography } from '@mui/material'
import startCase from 'lodash.startcase'
import { ComponentProps, useMemo } from 'react'

type TProps = ComponentProps<typeof Box> & {
  name: string
  website?: string | null
  size?: 'sm' | 'md'
}
/**
 * A component that displays a nam with a favicon of their website.
 * Useful for visually differentiating in lists.
 */
export const NameWithFavicon = (props: TProps) => {
  const { name, website, size, ...passedProps } = props
  const avatar = useMemo(() => {
    const avatarSx =
      size === 'sm'
        ? {
            width: 14,
            height: 14,
            mr: 0.5,
            fontSize: '0.65rem',
          }
        : {
            width: 20,
            height: 20,
            mr: 1,
            fontSize: '0.75rem',
          }
    if (!website) {
      const inits = startCase(name)
        .replace(/[^A-Z]/g, '')
        .slice(0, 2)
      return (
        <Avatar variant={size === 'sm' ? 'circular' : 'rounded'} sx={avatarSx}>
          {inits}
        </Avatar>
      )
    }
    const parsedUrl = new URL(website.startsWith('http') ? website : `https://${website}`)
    const rawDomain = parsedUrl.hostname.replace('www.', '')
    return (
      <Avatar
        variant={size === 'sm' ? 'circular' : 'rounded'}
        src={`https://www.google.com/s2/favicons?domain=${rawDomain}&sz=24`}
        sx={avatarSx}
      >
        {rawDomain[0].toUpperCase()}
      </Avatar>
    )
  }, [website, name, size])
  return (
    <Box display="flex" alignItems="center" {...passedProps}>
      {avatar}
      <Typography variant={size === 'sm' ? 'caption' : 'inherit'}>{name}</Typography>
    </Box>
  )
}
